import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import Typography from '@mui/material/Typography';
import makeStyles from '@mui/styles/makeStyles';
import PropTypes from 'prop-types';
import React from 'react';
import TrueLinkTextInput from 'react/shared/components/true_link/main/form/TrueLinkTextInput';

const useStyles = makeStyles({
  label: {
    color: '#000',
  },
  select: {
    height: 'auto',
    width: 'auto',
    paddingTop: '10px',
    paddingBottom: '10px',
    paddingLeft: '12px',
  },
});

export default function ReferralDropdown({ onChange, setFieldTouched, values }) {
  const classes = useStyles();

  const options = [
    {
      label: 'Email',
      value: 'email',
    },
    {
      label: 'Instagram',
      value: 'instagram',
    },
    {
      label: 'Facebook',
      value: 'facebook',
    },
    {
      label: 'Other Social Media',
      value: 'social_media',
    },
    {
      label: 'Internet Search',
      value: 'internet_search',
    },
    {
      label: 'Conference / Event',
      value: 'conference_or_event',
    },
    {
      label: 'Friend or Family',
      value: 'friend_or_family',
    },
    {
      label: 'Attorney',
      value: 'attorney',
    },
    {
      label: 'Professional or Organization',
      value: 'professional_or_organization',
    },
    {
      label: 'Television',
      value: 'television',
    },
    {
      label: 'Other',
      value: 'other',
    },
  ];

  return (
    <>
      <FormControl>
        <FormLabel className={classes.label} htmlFor="referralCategory">
          <Typography variant="body1">How did you hear about True Link?</Typography>
        </FormLabel>
        <select
          className={classes.select}
          id="referralCategory"
          name="referralCategory"
          onChange={onChange}
          placeholder="Select an option"
          required
          value={values.referralCategory}
        >
          <option key="no-data" value="" />
          {options.map((referrer) => (
            <option key={referrer.label} value={referrer.value}>
              {referrer.label}
            </option>
          ))}
        </select>
      </FormControl>
      {values.referralCategory && (
        <TrueLinkTextInput
          labelText="If applicable, share the name of the referrer"
          name="referralName"
          onChange={onChange}
          placeholder="Referrer name"
          setFieldTouched={setFieldTouched}
          value={values.referralName}
        />
      )}
    </>
  );
}

ReferralDropdown.propTypes = {
  onChange: PropTypes.func.isRequired,
  setFieldTouched: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired,
};
